import React from "react";
import AssetGrid from "./AssetGrid";

interface MannequinsTabProps {
  assets: BrandAsset[];
  projectId: string;
  onUpload: (file: File) => Promise<void>;
  onDelete: (assetId: string) => void;
  onUpdate: (assetId: string, updates: FormData) => void;
}

const MannequinsTab: React.FC<MannequinsTabProps> = ({ assets, projectId, onUpload, onDelete, onUpdate }) => {
  const mannequinAssets = assets.filter((a) => a.type === "mannequin");

  const renderMeta = (asset: BrandAsset) => {
    const desc = asset.metadata?.description;
    if (desc) {
      return <p className="text-xs text-gray-400 truncate">{desc}</p>;
    }
    return null;
  };

  return (
    <AssetGrid
      assets={mannequinAssets}
      assetType="mannequin"
      onUpload={onUpload}
      onDelete={onDelete}
      onUpdate={onUpdate}
      renderMeta={renderMeta}
      emptyMessage="No mannequins yet. Upload reference images of models your brand uses."
    />
  );
};

export default MannequinsTab;
